import { render, staticRenderFns } from "./CollectionLinks.vue?vue&type=template&id=08e593c3&scoped=true&lang=pug&"
import script from "./CollectionLinks.vue?vue&type=script&lang=js&"
export * from "./CollectionLinks.vue?vue&type=script&lang=js&"
import style0 from "./CollectionLinks.vue?vue&type=style&index=0&id=08e593c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e593c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e593c3')) {
      api.createRecord('08e593c3', component.options)
    } else {
      api.reload('08e593c3', component.options)
    }
    module.hot.accept("./CollectionLinks.vue?vue&type=template&id=08e593c3&scoped=true&lang=pug&", function () {
      api.rerender('08e593c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/CollectionLinks.vue"
export default component.exports